import React from "react";

import styles from "./tagFilterMenu.module.css";

// 未选「筛选 ▾」；选 1 个显示标签名；多个「A 等 N 个」。
function filterButtonText(selected) {
  if (!selected.length) return "筛选 ▾";
  if (selected.length === 1) return `${selected[0]} ▾`;
  return `${selected[0]} 等 ${selected.length} 个 ▾`;
}

// 标签表头里的多选下拉。面板用 position:fixed 按按钮位置定位——表格外层 .tableWrap 有 overflow，
// absolute 定位会被裁掉。counts 是 { 标签名: 行数 }。
export function TagFilterMenu({ tags, counts, selected, onChange }) {
  const [rect, setRect] = React.useState(null);
  const buttonRef = React.useRef(null);
  const panelRef = React.useRef(null);
  const open = rect !== null;

  React.useEffect(() => {
    if (!open) return undefined;
    const close = () => setRect(null);
    const onPointer = (event) => {
      if (panelRef.current?.contains(event.target) || buttonRef.current?.contains(event.target)) return;
      close();
    };
    const onKey = (event) => { if (event.key === "Escape") close(); };
    document.addEventListener("mousedown", onPointer);
    document.addEventListener("keydown", onKey);
    // 表格横向滚动或页面滚动后面板会脱离按钮，直接关掉比跟随更简单。
    window.addEventListener("scroll", close, true);
    window.addEventListener("resize", close);
    return () => {
      document.removeEventListener("mousedown", onPointer);
      document.removeEventListener("keydown", onKey);
      window.removeEventListener("scroll", close, true);
      window.removeEventListener("resize", close);
    };
  }, [open]);

  const toggle = (label) => onChange(
    selected.includes(label) ? selected.filter((item) => item !== label) : [...selected, label],
  );

  return (
    <>
      <button
        ref={buttonRef}
        type="button"
        className={styles.trigger}
        data-active={selected.length > 0}
        aria-haspopup="listbox"
        aria-expanded={open}
        onClick={() => {
          const box = buttonRef.current.getBoundingClientRect();
          setRect(open ? null : { top: box.bottom + 4, left: box.left });
        }}
      >
        <span className={styles.label}>{filterButtonText(selected)}</span>
      </button>
      {open && (
        <div ref={panelRef} className={styles.panel} style={{ top: rect.top, left: rect.left }} role="listbox" aria-multiselectable="true">
          {tags.length ? tags.map((label) => (
            <label key={label} className={styles.option}>
              <input type="checkbox" checked={selected.includes(label)} onChange={() => toggle(label)} />
              <span>{label}</span>
              <small>{counts[label] ?? 0}</small>
            </label>
          )) : <div className={styles.empty}>还没有标签</div>}
          <button type="button" className={styles.clear} disabled={!selected.length} onClick={() => onChange([])}>清除</button>
        </div>
      )}
    </>
  );
}
